// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    VERSION: require('../../package.json').version,
    production: false,
    ssoUrl: 'https://www.cityu.edu.hk/sro/studentlan/sso-cityu-staging.ashx',
    graphEndpoint: 'hasura-uat-console.cityu-sro.hk/v1/graphql',
    // refEndpoint: 'http://127.0.0.1:8082'
};

// goLogServer: 'http://localhost:8080/log',
// fbMailServer: 'http://localhost:8080/mail-request',

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
